import { render } from "./cnt-table_milestones_mfa.vue?vue&type=template&id=212657e6&scoped=true"
const script = {}

import "./cnt-table_milestones_mfa.vue?vue&type=style&index=0&id=212657e6&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-212657e6"]])

export default __exports__